export default __webpack_public_path__ + "static/media/confirmedIcon.76d640f6.svg";